export const FleetDetailsTabs = {
  EQUIPMENT: 'EQUIPMENT',
  SHARED_WITH: 'SHARED_WITH',
} as const;
